/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Directory_Detail_Published_OnInputs */

const en_directory_detail_published_on = /** @type {(inputs: Directory_Detail_Published_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Published on ${i?.date}`)
};

const zh_directory_detail_published_on = /** @type {(inputs: Directory_Detail_Published_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`发布于 ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Published on {date}" |
*
* @param {Directory_Detail_Published_OnInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_published_on = /** @type {((inputs: Directory_Detail_Published_OnInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Published_OnInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_published_on(inputs)
	return zh_directory_detail_published_on(inputs)
});
export { directory_detail_published_on as "directory.detail.published_on" }